import { SortItem } from '../ss-api/responses/member.dashboard.license.response';

export enum FileStatusTypes {
    Requested = 1,
    Uploaded = 2,
    Failed = 99
}

export enum FileTypes {
    General = 1,
    Logs = 2,
    Unknown = 99
}


export class FileUploadItem {
    ID: number;
    FilePath: string;
    BucketID: string;
    FileID: string;
    DownloadURL: string;
    FileStatusType: FileStatusTypes;
    FileType: FileTypes;
    ResultMessage: string;
    LicenseKey: string;
    AdminName: string;
    DateTimeCreated: Date;
    DateTimeUpdated: Date;

    public static FixDate(item: FileUploadItem) {
        item.DateTimeCreated = new Date(item.DateTimeCreated);
        item.DateTimeUpdated = new Date(item.DateTimeUpdated);
    }
}

export class FileUploadItemArray extends Array<FileUploadItem>  {
    public LastSort = new SortItem;

    constructor(...items: FileUploadItem[]) {
        super(...items);
        Object.setPrototypeOf(this, FileUploadItemArray.prototype);
    }


    public static FixDates(items: FileUploadItemArray) {
        items.forEach(x => FileUploadItem.FixDate(x));
    }

}
